import React from 'react'
import '../css/style.css'
import SubmitLink from '.././components/availableactions/submitLink.js'
import DownloadLink from '.././components/availableactions/downloadLink.js'
import appConfig from '.././resource/appConfig.js'
import FixErrorsLink from '.././components/availableactions/fixErrorsLink.js'
import { Badge } from 'react-bootstrap'

const VS = appConfig.reqStatuses.validationSuccessful,
    S = appConfig.reqStatuses.submit,
    VSW = appConfig.reqStatuses.validationSuccesswithErrors,
    FF = appConfig.reqStatuses.fulfilled,
    FWF = appConfig.reqStatuses.fulfilledWithFailures,
    VF = appConfig.reqStatuses.validationFailed,
    TO = appConfig.reqStatuses.timedOut

const ActionHeader = (props) => {
  const currentRequest = props.request
  let fileUploadDate = props.request.FILE_UPLOAD_DATE
  let fileuploadTime = props.request.FILE_UPLOAD_TIME
  return (
    <div>
      <div className="panel-heading" id="panel-heading">
          <Badge pill="true" varient="primary">{props.index}</Badge>
          <p id="file-upload-date">{"Request Creation Date: " + fileUploadDate.slice(0,10) + "\xa0\xa0" + fileuploadTime}</p>
          <div id="orginizations-paragraph">
              {!currentRequest.ORG_NAMES ? '' : <p>Organization(s): {currentRequest.ORG_NAMES.join(', ')} </p>}
          </div>
          <p>Request Status: {currentRequest.UPLOAD_TYPE === "4" ? 'CANCELED' : currentRequest.REQ_STATUS} </p>
          {(currentRequest.REQ_STATUS === VS && currentRequest.UPLOAD_TYPE !=="4") ?<SubmitLink apiAuthHeaders = {props.apiAuthHeaders} PassDataItems={currentRequest}/>:null}
          {((currentRequest.REQ_STATUS === VF || currentRequest.REQ_STATUS === VSW) && currentRequest.UPLOAD_TYPE !=="4" && (currentRequest.ERROR_COUNT && currentRequest.ERROR_COUNT <= appConfig.erroneousRowsCountLimit)) ? <FixErrorsLink PassDataItems={currentRequest}/>:null}
          {(currentRequest.REQ_STATUS === FF || currentRequest.REQ_STATUS === FWF || currentRequest.REQ_STATUS === S || currentRequest.REQ_STATUS === TO || currentRequest.UPLOAD_TYPE === "4" || ((currentRequest.REQ_STATUS === VF || currentRequest.REQ_STATUS === VSW) && (currentRequest.ERROR_COUNT && currentRequest.ERROR_COUNT > appConfig.erroneousRowsCountLimit))) ? <DownloadLink apiAuthHeaders={props.apiAuthHeaders} PassDataItems={currentRequest} />:null}
      </div>
    </div>
  )
}
export default ActionHeader
